import 'highlight.js/styles/atom-one-dark.css';

import hljs from 'highlight.js';

// ----------------------------------------------------------------------

hljs.configure({
  languages: ['javascript', 'jsx', 'sh', 'bash', 'html', 'scss', 'css', 'json'],
});

window.hljs = hljs;
